import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBookCoverBirdieLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 67,
	height: 50,
	viewBox: "0 0 67 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_i_14245_8169)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M66.5413 18.9499C66.6195 14.4702 66.6585 12.2303 65.8166 10.504C65.076 8.9856 63.8737 7.74058 62.382 6.94744C60.6862 6.04576 58.4463 6.00666 53.9666 5.92846L19.5457 5.32765C15.3686 5.25473 13.2801 5.21828 11.6235 5.97934C10.1649 6.64947 8.94154 7.74291 8.11257 9.11753C7.17112 10.6787 6.9739 12.7582 6.57947 16.9172L5.28576 30.5585C4.83851 35.2744 4.61488 37.6324 5.38467 39.4776C6.0612 41.0993 7.25283 42.4531 8.7755 43.33C10.508 44.3277 12.8753 44.4052 17.61 44.5601L53.0767 45.7207C57.6168 45.8693 59.8869 45.9435 61.6395 45.1118C63.1809 44.3803 64.448 43.1752 65.2559 41.6724C66.1745 39.9637 66.2141 37.6928 66.2934 33.1509L66.5413 18.9499Z",
				fill: "black",
				fillOpacity: .06
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M66.3913 18.9473C66.4304 16.7049 66.4595 15.0322 66.3743 13.704C66.2892 12.3776 66.0906 11.408 65.6818 10.5698C64.9551 9.07982 63.7753 7.85815 62.3116 7.07988C61.4881 6.64204 60.5261 6.40975 59.2035 6.27841C57.8791 6.1469 56.2063 6.11758 53.964 6.07844L19.5431 5.47762C17.4522 5.44113 15.8927 5.41401 14.6486 5.49047C13.4064 5.56682 12.4908 5.74598 11.6862 6.11564C10.2548 6.77321 9.05445 7.84615 8.24102 9.19499C7.78373 9.95328 7.50335 10.8431 7.28864 12.069C7.07361 13.2967 6.92624 14.8495 6.7288 16.9314L5.43509 30.5726C5.21123 32.9332 5.04432 34.6943 5.02882 36.0962C5.01333 37.4965 5.1494 38.5241 5.5231 39.4198C6.18695 41.0111 7.35623 42.3395 8.85036 43.2C9.69143 43.6843 10.6935 43.9497 12.0843 44.1121C13.4769 44.2747 15.245 44.3326 17.6149 44.4102L53.0816 45.5708C55.3541 45.6451 57.0495 45.7005 58.396 45.634C59.7408 45.5677 60.7242 45.3801 61.5752 44.9763C63.0876 44.2585 64.331 43.076 65.1237 41.6014C65.5698 40.7717 65.8064 39.799 65.9401 38.4592C66.074 37.1177 66.1037 35.4217 66.1434 33.1483L66.3913 18.9473Z",
			stroke: "black",
			strokeOpacity: .16,
			strokeWidth: .3
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter1_ddd_14245_8169)",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 3,
				y: 3.15186,
				width: 59.0754,
				height: 40,
				rx: 8,
				transform: "rotate(-1 3 3.15186)",
				fill: "white"
			}), /* @__PURE__ */ _jsx("rect", {
				x: 3.25433,
				y: 3.39745,
				width: 58.5754,
				height: 39.5,
				rx: 7.75,
				transform: "rotate(-1 3.25433 3.39745)",
				stroke: "black",
				strokeOpacity: .16,
				strokeWidth: .5
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_14245_8169)",
			children: [
				/* @__PURE__ */ _jsx("g", {
					filter: "url(#filter2_i_14245_8169)",
					children: /* @__PURE__ */ _jsx("path", {
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M38.4601 22.4601C38.7583 30.9985 32.0783 38.1619 23.5399 38.4601C15.0015 38.7582 7.83805 32.0782 7.53988 23.5398C7.24171 15.0014 13.9217 7.838 22.4601 7.53983C30.9985 7.24167 38.162 13.9217 38.4601 22.4601Z",
						fill: "url(#paint0_linear_14245_8169)"
					})
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M37.816 22.4826C38.1017 30.6652 31.7 37.5302 23.5174 37.8159C15.3348 38.1016 8.46979 31.7 8.18405 23.5173C7.89831 15.3347 14.3 8.46975 22.4826 8.184C30.6652 7.89826 37.5302 14.2999 37.816 22.4826Z",
					stroke: "black",
					strokeOpacity: .16,
					strokeWidth: 1.28913
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M19.8697 36.661C20.7658 35.8942 21.6896 35.0225 22.2885 33.9243C22.9706 32.676 23.121 31.2883 22.6928 30.2121C22.4963 29.7176 22.1985 29.3138 21.8092 29.0113C20.8509 28.2697 19.4033 28.2487 18.0301 28.956C17.7066 29.1221 17.5803 29.5186 17.7467 29.8405C17.9131 30.1631 18.3113 30.2884 18.6335 30.123C19.5334 29.6591 20.4609 29.632 20.9997 30.0482C21.2014 30.205 21.359 30.4232 21.4684 30.6977C21.7549 31.416 21.6284 32.3867 21.1314 33.2969C20.5328 34.3943 19.4974 35.2614 18.4961 36.0999L18.3604 36.2132C18.3544 36.2182 18.3484 36.2233 18.3424 36.2283C18.8399 36.3999 19.3497 36.5447 19.8697 36.661ZM13.1579 33.0709C13.9794 31.5519 14.9274 30.0357 15.9886 28.5442C16.3273 28.0681 16.6967 27.5753 17.1548 26.989C17.1942 26.9388 17.2964 26.8052 17.3226 26.6034C17.3446 26.4354 17.3016 26.3024 17.2817 26.2407L17.2812 26.2394C17.0276 25.4939 16.9415 24.6698 17.0021 23.5667C17.0446 22.7856 17.1988 22.0493 17.4596 21.3769C17.6665 20.8417 18.0734 20.0966 18.4524 19.7075C18.684 19.4699 18.7016 19.0966 18.4931 18.8386C18.2859 18.5825 18.0575 18.2764 17.9288 17.9531L17.8918 17.8647C18.0207 17.933 18.1256 17.9866 18.1752 18.0063C19.6463 18.589 20.8467 18.6842 22.0729 18.3215C22.431 18.2147 22.7614 18.1524 23.0282 18.1373C23.284 18.1334 23.5702 18.1627 23.8807 18.2243C23.8189 17.9565 23.7818 17.6789 23.7718 17.3939C23.7658 17.2193 23.77 17.0468 23.7841 16.8769C23.5092 16.8387 23.2429 16.8217 22.9824 16.826C22.5861 16.8476 22.1533 16.9271 21.6964 17.0634C20.7743 17.3388 19.8395 17.2518 18.6799 16.7948C18.5878 16.7525 18.0241 16.4444 17.7362 16.2653C17.449 16.0874 17.0745 16.1551 16.868 16.4211L16.7157 16.6176C16.6989 16.6396 16.6828 16.663 16.6693 16.6875C16.2612 17.3806 16.5108 17.974 16.6601 18.3284L16.705 18.4381C16.8208 18.7305 16.9767 18.9943 17.1402 19.2311C16.7399 19.7731 16.4134 20.4316 16.2304 20.9055C15.9199 21.7051 15.7378 22.5776 15.6871 23.4969C15.6244 24.652 15.7057 25.5609 15.9501 26.3957C15.5558 26.905 15.2238 27.3503 14.9142 27.7845C13.9097 29.1969 13.0031 30.6317 12.2048 32.0719C12.5064 32.4202 12.8245 32.7536 13.1579 33.0709ZM29.4903 35.44C29.73 34.7711 29.8984 34.08 29.9737 33.3789C30.1887 31.3777 29.5916 29.5888 28.2478 28.2065C27.9948 27.9454 27.5767 27.9399 27.3175 28.1921C27.0564 28.4444 27.05 28.8602 27.3029 29.1199C28.381 30.2293 28.8389 31.6153 28.6648 33.2393C28.555 34.2629 28.2154 35.2647 27.7351 36.1951C28.3403 35.9819 28.9264 35.7291 29.4903 35.44ZM25.6886 16.8737C26.7725 16.8358 27.6206 15.9264 27.5827 14.8424L28.4886 14.8108C28.5264 15.8948 29.4359 16.7428 30.5198 16.705L30.5515 17.6108C29.4675 17.6487 28.6195 18.5581 28.6573 19.6421L27.7514 19.6737C27.7136 18.5897 26.8041 17.7417 25.7202 17.7796L25.6886 16.8737ZM29.0532 21.4924C29.4915 21.3967 29.9043 21.2352 30.2812 21.0191C30.7278 22.2236 30.986 23.8847 30.4737 25.3287C30.1247 26.3137 29.4544 27.0608 28.5364 27.4895C28.2066 27.6428 27.8144 27.503 27.6608 27.1742C27.5065 26.8453 27.648 26.4548 27.9771 26.3009C28.5776 26.0204 28.9999 25.546 29.232 24.8915C29.6059 23.8376 29.4297 22.5112 29.0532 21.4924ZM25.1877 23.3674C25.9073 23.3423 26.4705 22.7399 26.4454 22.0223C26.4204 21.3046 25.8166 20.7431 25.097 20.7682C24.3774 20.7933 23.8142 21.3956 23.8392 22.1133C23.8643 22.831 24.4681 23.3925 25.1877 23.3674ZM19.8847 22.2618C19.8597 21.5441 20.4228 20.9418 21.1424 20.9167C21.862 20.8916 22.4659 21.4531 22.4909 22.1708C22.516 22.8884 21.9528 23.4908 21.2332 23.5159C20.5136 23.541 19.9098 22.9795 19.8847 22.2618Z",
					fill: "white"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M62.9653 16.0178L63.9652 16.0003C64.5174 15.9907 64.9728 16.4305 64.9825 16.9827L65.0523 20.9821C65.0619 21.5343 64.6221 21.9898 64.0699 21.9994L63.07 22.0168L62.9653 16.0178Z",
			fill: "#FF8637"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M52.9639 26.6487C55.3951 25.3894 56.8949 22.6014 56.2111 19.633C55.6551 17.2256 53.6403 15.3439 51.1878 14.895C47.071 14.15 43.47 17.2634 43.5387 21.1961C43.5816 23.6549 45.0547 25.7479 47.1557 26.7418L47.1816 28.2252C47.2092 29.8083 48.5488 31.0601 50.1359 31.0324C51.7225 31.0047 53.0173 29.7069 52.9896 28.1238L52.9639 26.6487ZM47.9219 25.7119L49.4122 25.6859L49.3569 22.5198L47.954 21.1607C47.7057 20.9233 47.6988 20.5318 47.9386 20.2775C48.1785 20.0316 48.5739 20.0247 48.8222 20.2621L49.9615 21.3656L51.0611 20.223C51.3009 19.9771 51.6964 19.9702 51.9447 20.2076C52.1932 20.4533 52.2 20.8448 51.9601 21.0907L50.6067 22.4971L50.662 25.6641L52.1799 25.6376C54.2586 24.6806 55.5602 22.3733 54.993 19.9126C54.5525 18.0117 52.9382 16.4813 50.9647 16.124C47.6044 15.5159 44.7339 18.0498 44.7885 21.1743C44.8242 23.2191 46.1032 24.9669 47.9219 25.7119ZM51.718 26.8958L51.7398 28.1456C51.7551 29.0205 51.0339 29.7665 50.114 29.7826C49.193 29.7987 48.4467 29.0783 48.4314 28.2034L48.4096 26.9536L49.9572 26.9266C49.9903 26.9315 50.0245 26.9337 50.0591 26.9331C50.0936 26.9325 50.1277 26.9291 50.1606 26.923L51.718 26.8958Z",
			fill: "black",
			fillOpacity: .32
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_i_14245_8169",
				x: 3.87744,
				y: 5.2915,
				width: 62.7021,
				height: 42.5223,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -1,
						dy: 2
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "shape",
						result: "effect1_innerShadow_14245_8169"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_ddd_14245_8169",
				x: .315818,
				y: .632246,
				width: 64.7744,
				height: 48.9037,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feMorphology", {
						radius: 1.91283,
						operator: "erode",
						in: "SourceAlpha",
						result: "effect1_dropShadow_14245_8169"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 5.14072 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.67372 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_14245_8169"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -.478207,
						dy: .71731
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.19552 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_14245_8169",
						result: "effect2_dropShadow_14245_8169"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feMorphology", {
						radius: 1.19552,
						operator: "erode",
						in: "SourceAlpha",
						result: "effect3_dropShadow_14245_8169"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: .119552,
						dy: 1.43462
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.79328 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect2_dropShadow_14245_8169",
						result: "effect3_dropShadow_14245_8169"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect3_dropShadow_14245_8169",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_i_14245_8169",
				x: 7.53027,
				y: 7.53021,
				width: 33.5177,
				height: 36.096,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: 2.57826,
						dy: 5.15651
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2.57826 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "shape",
						result: "effect1_innerShadow_14245_8169"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_14245_8169",
				x1: 39.1847,
				y1: 5.64402,
				x2: 6.81533,
				y2: 40.3559,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#C026D3" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#4F49BA"
				})]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip0_14245_8169",
				children: /* @__PURE__ */ _jsx("rect", {
					x: 7,
					y: 8.07971,
					width: 30.9391,
					height: 30.9391,
					rx: 15.4695,
					transform: "rotate(-2 7 8.07971)",
					fill: "white"
				})
			})
		] })
	]
});
export default SvgBookCoverBirdieLight;
